import DNI4Card from './DNI4Card';

export default DNI4Card;
